<template>
  <Modal v-model="modifyShow" width="800" footer-hide>
    <p slot="header" class="text-center">
      {{ optionType === 1 ? '新增通信资产' : '编辑通信资产' }}
    </p>

    <Form ref="formDataRef" :model="formData" :rules="formRules" label-position="top">
      <Row :gutter="8" class="m-b-10">
        <i-col span="8">
          <FormItem label="资产名称(编号)" prop="code">
            <i-input size="small" v-model="formData.code" placeholder="请输入资产名称/编号"/>
          </FormItem>
        </i-col>
        <i-col span="8">
          <FormItem label="所属线路" prop="assetId">
            <Select size="small" placeholder="选择所属线路" v-model="formData.assetId" @on-change="handleChangeAsset">
                <i-option
                  v-for="item in assetArray"
                  :key="'asset_' + item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </i-option>
            </Select>
          </FormItem>
        </i-col>
        <i-col span="8">
          <FormItem label="通信资产类型" prop="devicemodel">
            <Select size="small" placeholder="选择通信资产类型" v-model="formData.devicemodel">
              <i-option
                v-for="item in deviceModelArray"
                :key="'sModel_' + item.id"
                :value="item.id"
              >
                {{ item.name }}
              </i-option>
            </Select>
          </FormItem>
        </i-col>
        <i-col span="8">
          <FormItem label="位置名称" prop="stationId">
              <Select size="small" placeholder="请选择位置名称"
                :disabled="!formData.assetId" v-model="formData.stationId"
              >
                <i-option
                  v-for="item in stationArray"
                  :key="'station_' + item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </i-option>
              </Select>
            </FormItem>
        </i-col>
        <i-col span="8">
            <FormItem label="设备位置" prop="position">
              <Select size="small" placeholder="选择设备位置" v-model="formData.position">
                <i-option
                  v-for="item in positionArray"
                  :key="'position_' + item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </i-option>
              </Select>
            </FormItem>
        </i-col>
        <i-col span="8">
          <FormItem label="正线里程（km）">
            <InputNumber
              size="small"
              :max="99999"
              :min="0"
              v-model="formData.length"
              style="width:100%"
            >
            </InputNumber>
          </FormItem>
        </i-col>
        <i-col span="8">
            <FormItem label="车站建筑面积（㎡）">
              <InputNumber
                size="small"
                :max="99999"
                :min="0"
                v-model="formData.buildArea"
                style="width:100%"
              >
              </InputNumber>
            </FormItem>
        </i-col>
        <i-col span="8">
            <FormItem label="机房数量(个)">
              <InputNumber
                size="small"
                :max="99999"
                :min="0"
                v-model="formData.machineNumber"
                style="width:100%"
              >
              </InputNumber>
            </FormItem>
        </i-col>
        <i-col span="8">
            <FormItem label="设备点使用面积（㎡）">
              <InputNumber
                size="small"
                :max="99999"
                :min="0"
                v-model="formData.useArea"
                style="width:100%"
              >
              </InputNumber>
            </FormItem>
        </i-col>
        <i-col span="8">
            <FormItem label="配电限额（kw）">
              <InputNumber
                size="small"
                :max="99999"
                :min="0"
                v-model="formData.powerLimit"
                style="width:100%"
              >
              </InputNumber>
            </FormItem>
        </i-col>
        <i-col span="8">
            <FormItem label="设备点复用">
              <Select size="small" placeholder="选择设备点复用" v-model="formData.pointReuse">
                <i-option value="true">是</i-option>
                <i-option value="false">否</i-option>
              </Select>
            </FormItem>
        </i-col>
        <i-col span="8">
            <FormItem label="产权单位" prop="manageUnit">
              <Select
                size="small"
                placeholder="选择产权单位"
                v-model="formData.manageUnit"
              >
                <i-option
                  v-for="item in manageCompanyArray"
                  :key="'com_' + item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </i-option>
              </Select>
            </FormItem>
        </i-col>
        <i-col span="8">
            <FormItem label="管理单位" prop="usingUnit">
              <Select
                size="small"
                placeholder="选择管理单位"
                v-model="formData.usingUnit"
              >
                <i-option
                  v-for="item in manageCompanyArray"
                  :key="'com_' + item.id"
                  :value="item.id"
                >
                  {{ item.name }}
                </i-option>
              </Select>
            </FormItem>
        </i-col>
        <i-col span="16">
            <FormItem label="备注">
              <Input
                v-model="formData.remark"
                show-word-limit
                style="width:100%"
                size="small"
                type="textarea"
                maxlength='500'
                placeholder="请输入备注描述"
              />
            </FormItem>
          </i-col>
      </Row>

      <FormItem class="text-center m-t-20">
          <Button
            type="text"
            class="m-r-5"
            @click="handleCancel"
          >取消</Button>
          <Button
            type="primary"
            :loading="submitLoading"
            @click="handleSubmit"
          >确认录入</Button>
      </FormItem>
    </Form>
  </Modal>
</template>

<script>
import { getStationByAssetId } from '@/api/rim/station'
import { getDictionary } from '@/api/rim/dict'

import { getCompanyList } from '@/api/os/company'
import { submit } from '@/api/rim/device'

const getFomrData = () => {
  return {
    area: 0,
    assetId: null,
    certNo: '未办理',
    code: '',
    depth: 0,
    deviceBigmodel: 5, // 通信资产
    devicemodel: undefined,
    electric: 1,
    enabled: 1,
    exits: '',
    facilities: '', // 附加设备
    fault: false,
    fireApproval: 1,
    floorId: undefined,
    gasSupply: 1,
    height: 0,
    id: undefined,
    innerCode: '',
    manageUnit: null,
    model: '',
    name: '',
    orientation: '',
    position: null,
    publisherId: 0,
    quantity: 0,
    remark: '',
    street: '',
    stationId: undefined,
    transferTime: '',
    unit: '',
    uses: '',
    usingUnit: 0,
    waterSupply: 1,
    width: 0,
    openLease: 1,
    buildArea: 0,
    useArea: 0,
    property: undefined, // 物业\
    fireproof: '', // 防火要求
    smell: '', // 气味要求
    evacuation: '', // 疏散要求
    usagesTime: '', // 经营时间

    projectId: undefined, // 当前项目ID，传默认值
    length: 0, // 通信资产 里程数
    machineNumber: 0, // 通信资产 机房数量
    pointReuse: undefined, // 设备点复用
    powerLimit: 0 // 配电限额
  }
}

export default {
  props: {
    optionType: {
      type: Number,
      default: 1 // 1：新增，2：编辑
    },
    curDeviceInfo: [Object],
    assetArray: [Array],
    deviceModelArray: [Array],

    // curDeviceInfo: [Object],
    onSuccess: {
      type: Function,
      default: () => { }
    }
  },
  data () {
    return {
      modifyShow: false,
      childDeviceModelArray: [],
      stationArray: [],
      positionArray: [],
      manageCompanyArray: [],

      formData: getFomrData(),
      formRules: {
        code: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        assetId: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ],
        devicemodel: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ],
        stationId: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ],
        position: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ],
        floorId: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ],
        manageUnit: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ],
        usingUnit: [
          { required: true, type: 'number', message: ' ', trigger: 'change' }
        ]

      },

      submitLoading: false
    }
  },
  mounted () {
    this.initPageData()
  },
  methods: {
    showModal () {
      this.modifyShow = true
      // 重置数据
      Object.assign(this.formData, getFomrData())
      this.formData.projectId = this.$store.getters.token.userInfo.currentProjectId

      if (this.optionType !== 1) {
        // 编辑
        Object.keys(this.formData).forEach(key => {
          this.formData[key] = this.curDeviceInfo[key]
        })

        this.$nextTick(() => {
          this.handleChangeAsset()
        })
      }
    },
    initPageData () {
      this.getCompanyData()
      this.getPositionData()
      // this.getDeviceModelData()
    },
    handleChangeAsset () {
      this.getStationData()
    },
    getStationData () {
      getStationByAssetId({ assetId: this.formData.assetId }).then(res => {
        if (res && !res.errcode) {
          this.stationArray = res.filter(x => x.type === 15)
        } else {
          this.stationArray = []
        }
      })
    },
    getPositionData () {
      getDictionary({ code: 'tx_position' }).then(res => {
        if (res && !res.errcode) {
          this.positionArray = res.data.map(item => {
            return {
              id: parseInt(item.dictKey),
              name: item.dictValue
            }
          })
        } else {
          this.positionArray = []
        }
      })
    },
    getCompanyData () {
      const params = { enabled: true, publisherId: this.$store.getters.token.userInfo.publisherId }
      getCompanyList(params).then(res => {
        if (res && !res.errcode) {
          this.manageCompanyArray = res
        } else {
          this.manageCompanyArray = []
        }
      })
    },
    setAreaValue () {
      // 因为通信资产的计费策略，需要获取其中一个值，赋值给area
      if (this.formData.length) {
        this.formData.area = this.formData.length
      } else if (this.formData.machineNumber) {
        this.formData.area = this.formData.machineNumber
      } else if (this.formData.buildArea) {
        this.formData.area = this.formData.buildArea
      } else if (this.formData.useArea) {
        this.formData.area = this.formData.useArea
      }
    },
    handleCancel () {
      this.modifyShow = false
      this.$refs.formDataRef.resetFields()
    },
    handleSubmit () {
      this.$refs.formDataRef.validate(valid => {
        if (valid) {
          this.$Modal.confirm({
            title: '操作提示',
            content: '确定信息无误并提交？',
            onOk: async () => {
              this.submitLoading = true
              this.setAreaValue()
              const postData = Object.assign({}, this.formData)
              // postData.transferTime = this.formData.transferTime ? ParseDate(this.formData.transferTime) : ''
              // postData.facilities = this.formData.facilities.toString()
              // postData.usagesTime = this.formData.usagesTime ? JSON.stringify(this.formData.usagesTime) : ''
              // postData.uses = this.formData.uses

              const result = await submit(JSON.stringify(postData)).finally(() => {
                this.submitLoading = false
                this.modifyShow = false
              })
              if (result && result.errcode === 0) {
                this.$Notice.success({ title: '操作提示', desc: '提交成功' })
                this.onSuccess()
              } else {
                this.$Notice.error({ title: '操作提示', desc: '提交失败' })
              }
            }
          })
        }
      })
    }
  }
}
</script>
